import axios from '../axios'

/*
 * 提现申请
 */

export const selectByPage = (data) => {
    return axios({
        url: '/withdrawApply/selectByPage',
        method: 'post',
        data
    })
}
export const approveSuccess = (data) => {
    return axios({
        url: '/withdrawApply/approveSuccess',
        method: 'post',
        data
    })
}
export const approveFail = (data) => {
    return axios({
        url: '/withdrawApply/approveFail',
        method: 'post',
        data
    })
}
export const batchDisable = (data) => {
    return axios({
        url: '/project/batchDisable',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/project/batchEnable',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/project/batchDelete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/withdraw/apply.js